import AdmProperties from "./Properties";
export default AdmProperties;
